module.exports = __webpack_public_path__ + "img/Group 3166.6b75c093.png";